
import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  mounted () {},
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Purchases')
    },
    Tabs () {
      return [
        { Name: this.Translate('Purchases'), Link: 'Orders', Access: this.Access('Purchase_Orders_Read') },
        { Name: this.Translate('Vendors'), Link: 'Vendors', Access: this.Access('Purchase_Vendors_Read') }
      ] as Array<CookiesTabs>
    }
  },
  methods: {},
  watch: {}
})
